import {
  fetchArticleBehaviorsList,
  fetchArticleList,
  postSaleTransfer,
  postSaleTransition,
  saveArticleBehavior
} from "shadow-client/endpoints/saleApi";
import { fetchContact } from "shadow-client/endpoints/contactApi";
import moment from "moment";

const validCartToSale = (contactId, saleId) => async (dispatch, getState) => {
  const contactResponse = await dispatch(fetchContact(contactId));

  const articleList = await dispatch(fetchArticleList({ params: { sale: saleId } }));

  await dispatch(
    postSaleTransfer(saleId, {
      contactId: contactResponse.get("@id"),
      contactFamilyName: contactResponse.get("familyName"),
      contactGivenName: contactResponse.get("givenName"),
      contactNumber: contactResponse.get("number"),
      address: {
        addressCountry: contactResponse.getIn(["address", "addressCountry"]),
        addressLocality: contactResponse.getIn(["address", "addressLocality"]),
        postalCode: contactResponse.getIn(["address", "postalCode"]),
        streetAddress: contactResponse.getIn(["address", "streetAddress"])
      }
    })
  );

  await Promise.all(
    articleList["hydra:member"].map(async art => {
      const articleBehaviorsList = await dispatch(fetchArticleBehaviorsList({ params: { article: art.get("@id") } }));

      return await Promise.all(
        articleBehaviorsList["hydra:member"].map(async behavior => {
          return await dispatch(
            saveArticleBehavior(behavior.get("@id"), {
              ...behavior.toJS(),
              implementation: {
                ...behavior.get("implementation").toJS(),
                startDate: moment().format("YYYY-MM-DD"),
                contactId: contactResponse.get("@id"),
                articleId: art.get("@id")
              }
            })
          );
        })
      );
    })
  );

  const saleTransition = await dispatch(postSaleTransition(saleId, "validate"));

  return saleTransition;
};

export default validCartToSale;



// WEBPACK FOOTER //
// ./src/app/redux/actions/validCartToSale.js